import {
  ArgoCDApi,
  ArgoCDApiClient,
  Options,
} from '@roadiehq/backstage-plugin-argo-cd';
import {
  createApiRef,
  IdentityApi,
} from '@backstage/core-plugin-api';

export type ArgoCDClusterList = {
  items: [
    {
      server: string;
      name: string;
    },
  ];
};

export interface CustomArgoCDApi extends ArgoCDApi {
  listClusters(): Promise<ArgoCDClusterList>;
}

export const customArgoCDApiRef = createApiRef<CustomArgoCDApi>({
  id: 'plugin.customargocd.service',
});

export class CustomArgoCDApiClient
  extends ArgoCDApiClient
  implements CustomArgoCDApi
{
  private readonly customIdentityApi: IdentityApi;

  constructor(options: Options) {
    super(options);
    this.customIdentityApi = options.identityApi;
  }

  private async fetchDecodeCustom(url: string) {
    const { token } = await this.customIdentityApi.getCredentials();
    const response = await fetch(url, {
      headers: token
        ? {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          }
        : undefined,
    });
    if (!response.ok) {
      throw new Error(
        `failed to fetch data, status ${response.status}: ${response.statusText}`,
      );
    }
    return await response.json();
  }

  async listClusters(): Promise<ArgoCDClusterList> {
    const proxyUrl = await this.getBaseUrl();
    return this.fetchDecodeCustom(`${proxyUrl}/argocd/api/clusters`);
  }
}
